<template>
  <div :class="'card ' + (props.selected ? 'border-primary' : 'border-secondary')">
    <div class="card-body align-items-center justify-content-center">
      <div class="d-flex justify-content-center">
        <slot></slot>
      </div>
      <p class="card-title text-center mt-2">{{ props.title }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title: string;
  selected?: boolean;
}

const props = defineProps<Props>();
</script>

<style scoped lang="scss">
.card {
  height: 5.7rem !important;
  width: 5.7rem !important;
  align-items: center;
  box-shadow: 0 3px 6px #dedede;
}

.card-title {
  font-weight: 700;
  font-size: 0.75rem;
  color: #1d1e19;
  overflow: hidden;
  max-width: 5.5rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
}

.border-secondary {
  border-color: rgba(57, 76, 96, 0.15) !important;
}
.border-primary {
  border-color: rgba(29, 30, 25, 1) !important;
}
</style>
